/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Marketplace API
 * OpenAPI spec version: 1.0.0
 */

/**
 * * `m` - Meter
 * * `cm` - Centimeter
 * * `mm` - Millimeter
 * * `in` - Inch
 */
export type DimensionUnitEnum = typeof DimensionUnitEnum[keyof typeof DimensionUnitEnum];


export const DimensionUnitEnum = {
  m: 'm',
  cm: 'cm',
  mm: 'mm',
  in: 'in',
} as const;
